/* Dải danh mục trang collection — nút tiến/lùi.
   Nút chỉ bật khi danh sách dài quá khung; vừa khung thì ẩn hẳn để khỏi
   có hai nút chết nằm đó. Không có JS thì dải vẫn vuốt/cuộn được bình thường. */
(function () {
  'use strict';

  function setup(nav) {
    if (nav.dataset.egrCnavReady === '1') return;
    var list = nav.querySelector('.egr-cnav__list');
    var prev = nav.querySelector('.egr-cnav__arrow--prev');
    var next = nav.querySelector('.egr-cnav__arrow--next');
    if (!list || !prev || !next) return;
    nav.dataset.egrCnavReady = '1';

    function maxScroll() {
      return list.scrollWidth - list.clientWidth;
    }

    function update() {
      var max = maxScroll();
      // 4px đệm: tránh bật/tắt nhấp nháy do làm tròn subpixel
      nav.classList.toggle('has-scroll', max > 4);
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft >= max - 2;
    }

    function step() {
      return Math.max(160, list.clientWidth * 0.7);
    }

    prev.addEventListener('click', function () {
      list.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      list.scrollBy({ left: step(), behavior: 'smooth' });
    });

    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // Danh mục đang xem có thể nằm ngoài khung -> kéo vào giữa cho thấy ngay
    var active = list.querySelector('.egr-cnav__item.is-active');
    if (active) {
      var target = active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2;
      list.scrollLeft = Math.max(0, target);
    }

    update();
    // Font Be Vietnam Pro nạp sau có thể đổi bề rộng chữ -> đo lại
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
  }

  function init() {
    document.querySelectorAll('.egr-cnav').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor dựng lại section thì gắn lại
  document.addEventListener('shopify:section:load', init);
})();
